import Api from 'api/index'

const config = {
  baseURL: '/api/app/v1/payouts',
}

const api = new Api(config)

api.fetchPayoutsList = ({ ...rest }) => api.get(``, { ...rest })

export default api
